import React, { useCallback, useMemo } from 'react';
import { Box, ErrorMessage, Inscription,Text, TextAreaInput } from '@common-fe/common-fe';

import { REQUIRED_TEXT } from '@/common/constants.ts';
import theme from '@/styles/theme';

import { useRenewalSetupStore } from '../stores';

const MAX_NOTE_LENGTH = 800;

interface Props {
  title: string
  placeholder: string;
  showError: boolean;
  handleSetShowError: (value: boolean) => void;
}

const RenewalDetailsNote: React.FC<Props> = ({
  title,
  placeholder,
  showError,
  handleSetShowError,
}) => {
  const handlePlanDetailsNote = useRenewalSetupStore((state) => state.setPlanDetailsNote);
  const planDetailsNote = useRenewalSetupStore((state) => state.planDetailsNote);
  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
    const formattedValue = e.target.value;
    const slicedValue = formattedValue.slice(0, MAX_NOTE_LENGTH);
    handlePlanDetailsNote(slicedValue);
    if (showError) handleSetShowError(false);
  }, [handlePlanDetailsNote, handleSetShowError, showError]);

  const errorText = useMemo(() => showError && !planDetailsNote ? REQUIRED_TEXT : undefined, [planDetailsNote, showError]);
  
  return (
    <Box pad="l" background="canvas" round="container1Round" data-testid="renewal-details-note-wrapper" border={{ color: 'border1' }}>
      <Box direction="row" margin={{ bottom: 'xs' }}>
        <Text
          color="danger"
          weight="bold"
          size="medium"
          margin={{ right: 'xxsmall' }}
        >
          *
        </Text>
        <Inscription weight="bold" lineHeight="20px" color="textBody">{title}</Inscription>
      </Box>
      <TextAreaInput
        placeholder={placeholder}
        value={planDetailsNote}
        onChange={handleChange}
        style={{
          minHeight: '240px',
          borderColor: errorText ? theme.colors.danger : undefined,
          borderWidth: errorText ? '2px' : undefined
        }}
      />
      {errorText && (
        <Box margin={{ top: 'spacing8' }}>
          <ErrorMessage errorText={errorText} errorStyle={{ fontWeight: 500 }} />
        </Box>
      )}
    </Box>
  );
};

export default RenewalDetailsNote;
